import React from 'react'
import { makeStyles } from '@material-ui/core'
import StyledSwitch from './StyledSwitch'
import StyledIconWithTooltip from './StyledIconWithTooltip'
import { gray } from '../../utils/colors'
import { FONT_WEIGHTS } from '../../utils'

const useStyles = makeStyles(() => ({
	root: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		backgroundColor: gray[200],
		height: '3.5rem',
		borderRadius: '0.375rem',
		padding: '0 .75rem',
		flex: 1
	},
	label: {
		fontSize: '1rem',
		fontFamily: 'Nunito',
		fontWeight: FONT_WEIGHTS.SemiBold,
		color: gray[800],
		flex: 1,
		display: 'flex',
		gap: '.4rem'
	}
}))

const StyledSwitchWithLabel = ({
	label = 'LABEL',
	checked = false,
	onChecked,
	disabled = false,
	tooltip = null
}) => {
	const classes = useStyles()

	return (
		<div className={classes.root}>
			<div className={classes.label}>
				{label}
				{tooltip && !disabled ? (
					<StyledIconWithTooltip
						tooltipChildren={tooltip.tooltipChildren || undefined}
						tooltipText={tooltip.tooltipText || ''}
						faIcon={tooltip.faIcon || undefined}
						skiptownvariant={tooltip.skiptownvariant || undefined}
					/>
				) : null}
			</div>
			<StyledSwitch checked={checked} onChecked={onChecked} disabled={disabled} />
		</div>
	)
}

export default StyledSwitchWithLabel
